module.exports = __webpack_public_path__ + "static/img_9809_dpp_optimized-35067ecbd22b778b3fb42582931c0030.jpg";